export const movementReasonArray = [
    { text: 'Оптимизация остатков товара между точками одного клиента', value: 1 },
    { text: 'Подготовка к проведению акций или мероприятий)', value: 2 },
    { text: 'Перераспределение товара при закрытии/открытии точек)', value: 3 },
    { text: 'Порча товара (истек срок годности, повреждена упаковка)', value: 4 },
    { text: 'Бой, утрата товара', value: 5 },
    { text: 'Технические потери (усушка, утруска)', value: 6 },
    { text: 'Списание образцов и тестеров', value: 7 },
]
